import { render } from "./CollectionDetailedSearchAudioVisualMaterials.vue?vue&type=template&id=1899c3c5&scoped=true&ts=true"
import script from "./CollectionDetailedSearchAudioVisualMaterials.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchAudioVisualMaterials.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchAudioVisualMaterials.vue?vue&type=style&index=0&id=1899c3c5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1899c3c5"]])

export default __exports__